import { render, staticRenderFns } from "./RelHotelEvent.vue?vue&type=template&id=2f7e4b0c&scoped=true"
import script from "./RelHotelEvent.vue?vue&type=script&lang=js"
export * from "./RelHotelEvent.vue?vue&type=script&lang=js"
import style0 from "./RelHotelEvent.vue?vue&type=style&index=0&id=2f7e4b0c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f7e4b0c",
  null
  
)

export default component.exports